







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { IGroup } from '@/api/types';

type HeaderType = {
  text: string;
  value: string;
};

@Component({
  name: 'GroupListResult',
})
export default class extends Vue {
  @Prop({ required: true }) groups!: IGroup[];
  private headers: HeaderType[] = [];
  private loading = false;
  private filterText = '';

  mounted() {
    this.loadHeaders();
  }

  private loadHeaders() {
    // const id: HeaderType = {
    //   text: this.$t('{msg} Id', { msg: this.$t('Group') }) as string,
    //   value: 'id',
    // };
    const supplierId: HeaderType = {
      text: this.$t('Supplier Id') as string,
      value: 'supplierId',
    };
    const name: HeaderType = {
      text: this.$t('{msg} name', { msg: this.$t('Group') }) as string,
      value: 'name',
    };
    const isInactive: HeaderType = {
      text: `${this.$t('Active')}/${this.$t('Inactive')}`,
      value: 'isInactive',
    };
    const operations: HeaderType = {
      text: this.$t('Operations') as string,
      value: 'operations',
    };
    const headers: HeaderType[] = [name, supplierId, isInactive, operations];
    this.headers = headers;
  }

  private getIsInactiveText(isInactive: boolean) {
    return isInactive ? this.$t('Inactive') : this.$t('Active');
  }

  private navigate(group: IGroup) {
    this.$router.push({
      name: 'group-detail',
      params: {
        id: group.id!,
      },
    });
  }
}
